/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ProcessingMode } from './processingMode';
import type { ProcessingOptionsProcessorModes } from './processingOptionsProcessorModes';

/**
 * Options for configuring resource processing behavior
 */
export interface ProcessingOptions {
  defaultMode?: ProcessingMode;
  processorModes?: ProcessingOptionsProcessorModes;
  forceRebuildTypes?: string[];
  readFilmAgain?: boolean;
}
